module.exports = __webpack_public_path__ + "img/img19.84ec7116.svg";